import { render } from "./GridDatav.vue?vue&type=template&id=21ed1512&scoped=true"
import script from "./GridDatav.vue?vue&type=script&lang=js"
export * from "./GridDatav.vue?vue&type=script&lang=js"

import "./GridDatav.vue?vue&type=style&index=0&id=21ed1512&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21ed1512"

export default script